import FormInput from '~/components/form-input/FormInput.vue';
import { mapState } from 'vuex';
import { post } from '~/utils/adapi';
import { updateUser } from '~/utils/auth';

export default {
  components: {
    'form-input': FormInput,
  },
  data() {
    return {
      name: '',
      surname: '',
      errors: null,
      showMessage: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    errorArray() {
      return Array.isArray(this.errors) ? this.errors : [this.errors];
    },
  },
  methods: {
    handleProfileUpdateResponse(errors = null) {
      this.errors = errors;
      this.showMessage = true;
      if (!errors) {
        updateUser();
      }
    },
    updateProfile() {
      this.errors = null;
      this.showMessage = false;
      post('users/update-profile', null, {
        name: this.name,
        surname: this.surname,
      })
        .then(() => this.handleProfileUpdateResponse())
        .catch(errors => this.handleProfileUpdateResponse(errors));
    },
  },
  watch: {
    user(user) {
      this.name = user.name;
      this.surname = user.surname;
    },
  },
  mounted() {
    this.name = this.user.name;
    this.surname = this.user.surname;
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/account/profile/Profile.js